<script>
import Icon from '~/components/icon.vue';

export default {
  components: {
    Icon
  },

  props: {
    usp: {
      type: String,
      required: true
    },
    checkmarkStyle: {
      type: String,
      required: false,
      default: 'primary'
    }
  },
  computed: {
    classes() {
      return `c-checkmark me-3 c-checkmark--${this.checkmarkStyle}`;
    }
  }
};
</script>

<template>
  <li class="d-flex align-items-center">
    <div :class="classes">
      <icon
        name="check"
        size="small"
      />
    </div>

    {{ usp }}
  </li>
</template>
